export const allDevicesUrl = (id) => `/api/device/allDevices/:${id}`;
export const deviceUrl = (id) => `/api/device/edit/${id}`;
export const addNewDeviceUrl = (id) => `/api/device/add/:${id}`;
export const deleteDeviceUrl = (id) => `/api/device/delete/${id}`;
export const allValuesUrl = (id) => `/api/device/allValues/${id}`;
export const allValuesFromTimeUrl = () => `/api/device/allValuesFromTime`;
export const refreshUrl = () => `/api/device/refreshData`;
export const downloadUrl = () => `/api/device/betweenDates`;
export const getAllDatesUrl = () => `/api/device/allDates`;